import { createStyles } from 'antd-style';

import fullLogo from '../resources/img/quick-online-logo.svg';
import qLogo from '../resources/img/quick-online-logo-q.svg';

export const useLogoStyles = createStyles(({ token }) => ({
  logo: {
    position: 'relative',
    backgroundImage: `url('${fullLogo}')`,
    backgroundSize: '100% 100%',
    height: '100%',

    '&.size-sm': {
      width: 173,
      height: 42,
    },

    '&.size-md': {
      width: 192.5,
      height: 42,
    },

    '&.size-lg': {
      width: 180,
      height: 42,

      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          width: 173,
          height: 42,
        },
    },

    '> img': {
      height: '100%',
      width: 'auto',
    },

    [`@media (max-width: ${token.screenSMMax}px)`]: {
      '&:not(.always-full-image)': {
        backgroundImage: `url('${qLogo}')`,
        width: 33,
        height: 35,
      },
    },
  },
  logoQ: {
    backgroundImage: `url('${qLogo}')`,
    backgroundSize: '100% 100%',

    '&.size-xs': {
      width: 21,
      height: 20,
    },
    '&.size-sm': {
      width: 30,
      height: 28,
    },
    '&.size-md': {
      width: 43,
      height: 45,

      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          width: 33,
          height: 35,
        },
    },
    '&.size-lg': {
      width: 60,
      height: 58,

      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          width: 38,
          height: 40,
        },
    },
  },
}));
